import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { ApiserviceService } from 'src/app/Service/apiservice.service';
import { AgentscriptService_updated } from 'src/app/services/agent-script-service/agent-script-service';
import { ObjectController } from 'src/app/services/object-controller/objectcontroller.service';
import { QueryProcessorService } from 'src/app/services/query-services/query-processor.service';
import { StandardUIService } from 'src/app/services/standardui-service/standardui-service';
import Swal from 'sweetalert2/dist/sweetalert2.js';

declare var $: any;

export interface ContactLookupDialogData {
  phonenumber?: string;
  firstname?: string;
  lastname?: string;
  email?: string;
  street?: string;
}

/**
 * Contact search / select (query 23) with optional **New contact** flow aligned to `AddressDialogComponent`.
 */
@Component({
  selector: 'app-contact-lookup-dialog',
  templateUrl: './contact-lookup-dialog.component.html',
  styleUrls: ['./contact-lookup-dialog.component.scss']
})
export class ContactLookupDialogComponent implements OnInit, OnDestroy {
  @ViewChild(MatPaginator) paginator: MatPaginator;

  dataSource = new MatTableDataSource<any>();
  displayedColumns = [
    { id: '#', displayName: 'id' },
    { id: 'First Name', displayName: 'First Name' },
    { id: 'Last Name', displayName: 'Last Name' },
    { id: 'Phone Number', displayName: 'Phone Number' },
    { id: 'Email Address', displayName: 'Email' },
    { id: 'Address Line 1', displayName: 'Mailing Address' }
  ];

  tableId = 'contactLookupListTable_' + Math.floor(Math.random() * 1e9);
  myGroup: FormGroup;
  newcontact: FormGroup;
  subscription?: Subscription;
  jsonData: any;
  rowcolumns: any;
  rowdata: any[] = [];
  offset = 0;
  perPage = 100;
  pageNo = 1;
  onset = this.perPage;
  loadingImage = false;
  datatableload = true;
  states: any[] = [];
  country: any[] = [];
  maxDate: string;
  tab_title: any;

  showNewContactSection = false;
  showContactErrorMessage = false;
  showContactAlreadyExistsMessage = false;
  showSuccessMessage = false;
  showDataCondition = false;
  dataerror: any;
  entiredata: any;
  addressSuggestions: any[] = [];
  addressvalue: any;
  selectedcountry: any;
  picklistcountry: any;
  selected: any;
  pickliststate: any;

  constructor(
    public dialogRef: MatDialogRef<ContactLookupDialogComponent>,
    private queryProcessorService: QueryProcessorService,
    private ss: StandardUIService,
    private fb: FormBuilder,
    private objectcontrolservice: ObjectController,
    private agentscriptservice: AgentscriptService_updated,
    private apiservice: ApiserviceService,
    @Inject(MAT_DIALOG_DATA) public data: ContactLookupDialogData
  ) {
    const today = new Date();
    this.maxDate = this.formatDate(today);
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  customNameValidator(control: AbstractControl): { [key: string]: boolean } | null {
    const value = control.value;
    if (value && String(value).toLowerCase().includes('anonymous')) {
      return { invalidName: true };
    }
    return null;
  }

  emailValidator(group: FormGroup): void {
    const emailValue = group.get('email')?.value;
    if (!(emailValue == null || emailValue === '' || emailValue === undefined)) {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailValue || emailPattern.test(emailValue)) {
        group.get('email')?.setErrors(null);
      } else {
        group.get('email')?.setErrors({ invalidEmail: true });
      }
    } else {
      group.get('email')?.setErrors(null);
    }
  }

  private newContactEmailGroupValidator(): ValidatorFn {
    return (c: AbstractControl): ValidationErrors | null => {
      this.emailValidator(c as FormGroup);
      return null;
    };
  }

  private newContactSearchParamsOmitEmpty(): Record<string, string> {
    const v = this.newcontact?.value;
    if (!v) {
      return {};
    }
    const raw: Record<string, unknown> = {
      lastname: v.lastname,
      firstname: v.firstname,
      phonenumber: v.phonenumber,
      email: v.email,
      street: v.street
    };
    const out: [string, string][] = [];
    for (const [key, val] of Object.entries(raw)) {
      if (val == null) {
        continue;
      }
      let s = String(val).trim();
      if (s === '') {
        continue;
      }
      if (key === 'phonenumber') {
        s = s.replace(/\D/g, '');
        if (s === '') {
          continue;
        }
      }
      out.push([key, s]);
    }
    return Object.fromEntries(out) as Record<string, string>;
  }

  private trimStringValuesInObject(obj: Record<string, unknown>): Record<string, unknown> {
    const out: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(obj)) {
      if (typeof v === 'string') {
        const t = v.trim();
        if (t === '') {
          continue;
        }
        out[k] = t;
      } else {
        out[k] = v;
      }
    }
    return out;
  }

  ngOnInit(): void {
    try {
      this.tab_title = $('.custom-tabs li.active').find('a').attr('data-obj-title');
    } catch {
      this.tab_title = undefined;
    }

    this.myGroup = this.fb.group({
      lastname: [''],
      firstname: [''],
      phonenumber: [''],
      email: [''],
      postalcode: [''],
      street: [''],
      city: [''],
      stateprovience: [''],
      country: ['']
    });

    this.newcontact = this.fb.group(
      {
        nameprefix: [],
        firstname: ['', [Validators.required, this.customNameValidator.bind(this)]],
        namemiddle: [],
        lastname: ['', [Validators.required, this.customNameValidator.bind(this)]],
        namesuffix: [],
        phonenumber: ['', [Validators.minLength(14)]],
        alternateph: [''],
        language: [],
        email: [''],
        emailalt1: [''],
        dob: [],
        companyname: [],
        street: [''],
        city: [''],
        stateprovience: [''],
        postalcode: [''],
        country: ['']
      },
      { validators: [this.newContactEmailGroupValidator()] }
    );

    this.picklist();

    const d = this.data || {};
    const p = d.phonenumber ?? '';
    const digits = String(p).replace(/\D/g, '');
    if (digits.length >= 10) {
      this.myGroup.get('phonenumber')?.setValue(this.formatPhoneNumber(digits));
      this.newcontact.get('phonenumber')?.setValue(this.formatPhoneNumber(digits));
    } else if (p) {
      this.myGroup.get('phonenumber')?.setValue(String(p).trim());
    }
    const trim = (s?: string) => (s ?? '').trim();
    if (trim(d.firstname)) {
      this.myGroup.get('firstname')?.setValue(trim(d.firstname));
    }
    if (trim(d.lastname)) {
      this.myGroup.get('lastname')?.setValue(trim(d.lastname));
    }
    if (trim(d.email)) {
      this.myGroup.get('email')?.setValue(trim(d.email));
    }
    if (trim(d.street)) {
      this.myGroup.get('street')?.setValue(trim(d.street));
    }
    const hasCriteria =
      digits.length >= 10 ||
      !!trim(d.firstname) ||
      !!trim(d.lastname) ||
      !!trim(d.email) ||
      !!trim(d.street);
    if (hasCriteria) {
      setTimeout(() => {
        this.search({ queryId: '23', offset: 0, perpage: this.perPage });
      }, 400);
    }
  }

  ngOnDestroy(): void {
    try {
      this.subscription?.unsubscribe();
    } catch {
      /* noop */
    }
    try {
      const sel = '#' + this.tableId;
      if ($.fn.dataTable && $.fn.dataTable.isDataTable(sel)) {
        ($(sel) as any).DataTable().destroy(true);
      }
    } catch {
      /* noop */
    }
  }

  picklist(): void {
    const picklistIDs = [114, 115];
    picklistIDs.forEach((picklistID) => {
      this.ss.getPicklistByID(picklistID).subscribe((data) => {
        const picklistValues: any[] = [];
        for (const key in data) {
          if (data[key].active === true || data[key].active === '') {
            picklistValues.push({ key: data[key].id, value: data[key].valueen });
          }
        }
        if (picklistID === 114) {
          this.states.push(...picklistValues);
          const targetValue = 'United States (US)';
          let targetObject: any = null;
          for (let i = 0; i < this.states.length; i++) {
            if (this.states[i].value === targetValue) {
              targetObject = this.states[i];
              break;
            }
          }
          if (targetObject) {
            this.selectedcountry = targetObject.value;
            this.picklistcountry = targetObject.value;
          }
        } else if (picklistID === 115) {
          this.country.push(...picklistValues);
          const targetValue = 'IN';
          let targetObject: any = null;
          for (let i = 0; i < this.country.length; i++) {
            if (this.country[i].value === targetValue) {
              targetObject = this.country[i];
              break;
            }
          }
          if (targetObject) {
            this.selected = targetObject.value;
            this.pickliststate = targetObject.value;
          }
        }
      });
    });
  }

  truncateAddress(address: string): string {
    if (!address) {
      return '';
    }
    const maxLength = 20;
    return address.length > maxLength ? address.slice(0, maxLength) + '...' : address;
  }

  getcolumnvalues(id: any): number {
    return this.rowcolumns?.findIndex((column: string) => column === id) ?? -1;
  }

  hidemessage(): void {
    this.dataSource.filteredData = [];
  }

  datatablepagination(): void {
    this.loadingImage = true;
    $('#' + this.tableId + '_wrapper').remove();
    setTimeout(() => {
      ($('#' + this.tableId) as any).dataTable({
        pageLength: this.perPage,
        order: [[2, 'asc']],
        columnDefs: [
          { orderable: false, targets: 0 },
          { orderable: false, targets: 6 }
        ],
        fixedColumns: { start: 2, end: 1 },
        paging: true,
        fixedHeader: true,
        scrollY: 400,
        destroy: true,
        dom: 'frt',
        drawCallback(settings: any) {
          const api = new ($ as any).fn.dataTable.Api(settings);
          const rows = api.rows({ page: 'current' }).nodes();
          let startIndex = api.page() * api.page.len() + 1;
          $(rows).each(function (this: HTMLElement) {
            $('td', this).eq(0).html(String(startIndex));
            startIndex++;
          });
        }
      });
      this.loadingImage = false;
    }, 200);
    this.datatableload = true;
  }

  prev(): void {
    if (this.offset > 0) {
      this.offset -= this.perPage;
      this.pageNo--;
      this.onset = this.pageNo * this.perPage;
      this.search({ queryId: '23', offset: this.offset, perpage: this.perPage });
    }
  }

  next(): void {
    this.offset += this.perPage;
    this.pageNo++;
    this.onset = this.pageNo * this.perPage;
    this.search({ queryId: '23', offset: this.offset, perpage: this.perPage });
  }

  perPagechange(): void {
    this.pageNo = 1;
    this.search({ queryId: '23', offset: 0, perpage: this.perPage });
  }

  clearcontactsearch(): void {
    const phonenumber = this.myGroup.get('phonenumber')?.value;
    this.myGroup.reset();
    this.myGroup.get('phonenumber')?.setValue(phonenumber);
  }

  clearnewcontact(): void {
    const phonenumber = this.newcontact.get('phonenumber')?.value;
    this.newcontact.reset();
    this.newcontact.get('phonenumber')?.setValue(phonenumber);
  }

  toggleNewContactSection(): void {
    const opening = !this.showNewContactSection;
    this.showNewContactSection = opening;
    this.entiredata = [];
    this.addressSuggestions = [];
    this.showContactErrorMessage = false;
    this.showContactAlreadyExistsMessage = false;
    this.dataSource.data = [];
    this.jsonData = [];
    this.rowdata = [];
    if (opening) {
      (['firstname', 'lastname', 'email', 'street', 'phonenumber'] as const).forEach((k) => {
        const v = this.myGroup.get(k)?.value;
        if (v != null && String(v).trim() !== '') {
          this.newcontact.get(k)?.setValue(v);
        }
      });
    }
  }

  showdata(): void {
    const ph = this.myGroup.get('phonenumber')?.value;
    if (ph && String(ph).length === 14) {
      this.newcontact.get('phonenumber')?.setValue(ph);
    }
    if (this.apiservice.gensysdata && this.apiservice.gensysdata.geneSysData) {
      this.showDataCondition = true;
      this.newcontact.get('email')?.clearValidators();
      this.newcontact.get('email')?.updateValueAndValidity();
    } else {
      this.showDataCondition = false;
      this.newcontact.get('email')?.setValidators([Validators.required, Validators.email]);
      this.newcontact.get('email')?.updateValueAndValidity();
    }
  }

  showJsonData(): void {
    const ph = this.newcontact.get('phonenumber')?.value;
    if (ph && String(ph).length === 14) {
      this.myGroup.get('phonenumber')?.setValue(ph);
    }
    this.entiredata = [];
    this.addressSuggestions = [];
    this.showNewContactSection = false;
    this.jsonData = [];
  }

  closeSuccessMessage(): void {
    this.showSuccessMessage = false;
  }

  closeContactAlreadyExistsMessage(): void {
    this.showContactAlreadyExistsMessage = false;
  }

  suggestionSearch(): void {
    this.addressvalue =
      this.showNewContactSection === true
        ? this.newcontact?.get('street')?.value
        : this.myGroup?.get('street')?.value;
    if (this.addressvalue != null && this.addressvalue !== undefined && this.addressvalue.length > 0) {
      this.performAddressSearch(this.addressvalue);
    } else {
      this.addressSuggestions = [];
    }
  }

  performAddressSearch(searchTerm: any): void {
    this.agentscriptservice.mapsuggestions(searchTerm).subscribe((response: any) => {
      this.entiredata = response.suggestions;
      this.addressSuggestions = response.suggestions.map((suggestion: { text: string }) => suggestion.text);
    });
  }

  assignAddress(item: any): void {
    this.addressSuggestions = [];
    const streetAddress = item.split(',')[0].trim();
    this.addressvalue = item;
    this.agentscriptservice.fetchaddressdetails(streetAddress, 'Address', '').subscribe((data: any) => {
      const fetchaddressdetails = data;
      if (this.tab_title) {
        this.agentscriptservice.updateOrInsertArray(this.tab_title, 'mapdata', fetchaddressdetails);
      }
      if (fetchaddressdetails.msg) {
        Swal.fire({
          title:
            '<div class="popup-content"><div class="popup-text"> <img src="../../assets/images/warning.svg" class="animated-check" >please enter valid address</div></div>',
          icon: 'error',
          imageUrl: 'https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg',
          imageHeight: 45,
          showCloseButton: true,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonText: `OK`,
          cancelButtonText: 'Cancel'
        });
      } else {
        this.agentscriptservice.locationcoordinates = fetchaddressdetails;
        const coords = {
          msr_city: 'FORT WAYNE',
          msr_state: 'IN',
          msr_zip: fetchaddressdetails?.personal_data?.property_address_zip
            ? fetchaddressdetails.personal_data.property_address_zip
            : '46802',
          msr_serviceaddress: fetchaddressdetails?.returned_address
        };
        const matchedOption = this.country.find((option: any) => option.value === coords.msr_state);
        if (matchedOption) {
          this.newcontact.get('stateprovience')?.setValue(matchedOption.value);
        }
        this.newcontact.get('street')?.setValue(coords.msr_serviceaddress);
        this.newcontact.get('city')?.setValue(coords.msr_city);
        this.newcontact.get('postalcode')?.setValue(coords.msr_zip);
      }
    });
  }

  filterEmptyValues(payload: any): any {
    const filteredPayload = { ...payload };
    for (const key in filteredPayload) {
      if (filteredPayload[key] == null || filteredPayload[key] === '') {
        delete filteredPayload[key];
      }
    }
    return filteredPayload;
  }

  onSubmit(): void {
    this.showContactErrorMessage = false;
    this.showContactAlreadyExistsMessage = false;

    const addressid =
      (this.newcontact.value.street ? this.newcontact.value.street + ' \n' : '') +
      (this.newcontact.value.city ? this.newcontact.value.city + ' ' : '') +
      (this.newcontact.value.stateprovience ? this.newcontact.value.stateprovience + ' ' : '') +
      (this.newcontact.value.postalcode ? this.newcontact.value.postalcode : '');

    const contactPayload: Record<string, unknown> = {
      'Contact.nameprefix': this.newcontact.value.nameprefix,
      'Contact.namemiddle': this.newcontact.value.namemiddle,
      'Contact.namesuffix': this.newcontact.value.namesuffix,
      'Contact.language': this.newcontact.value.language,
      'Contact.dob': this.newcontact.value.dob,
      'Contact.companyname': this.newcontact.value.companyname,
      'Contact.lastname': this.newcontact.value.lastname,
      'Contact.firstname': this.newcontact.value.firstname,
      'Contact.phonenumber': this.newcontact.value.phonenumber,
      'Contact.alternateph': this.newcontact.value.alternateph,
      'Contact.email': this.newcontact.value.email,
      'Contact.emailalt1': this.newcontact.value.emailalt1,
      'Contact.postalcode': this.newcontact.value.postalcode,
      'Contact.street': this.newcontact.value.street,
      'Contact.city': this.newcontact.value.city,
      'Contact.addressid': addressid,
      'Contact.countryid': 1,
      'Contact.providenceid': 19
    };
    const contactPayloadfilter = Object.fromEntries(
      Object.entries(contactPayload).filter(([, value]) => value !== '' && value != null)
    );
    const contactPayloadArray = { entityName: 'Contact', payLoad: contactPayloadfilter };
    const params1 = this.newContactSearchParamsOmitEmpty();

    if (!this.newcontact.value.lastname || !this.newcontact.value.firstname) {
      return;
    }

    this.subscription?.unsubscribe();
    this.subscription = this.queryProcessorService
      .searchQueriesService({ queryId: '23', offset: 0, params: params1 })
      .subscribe((data) => {
        this.jsonData = data;
        this.rowcolumns = data.cols;
        this.rowdata = data.rows || [];
        this.dataSource = new MatTableDataSource(data.rows);
        this.dataSource.paginator = this.paginator;

        if (data.rows.length === 0) {
          this.objectcontrolservice.entityCreate(contactPayloadArray).subscribe((res: any) => {
            this.dataerror = res.error;
            const params = {
              lastname: this.newcontact.value.lastname,
              firstname: this.newcontact.value.firstname,
              phonenumber: this.newcontact.value.phonenumber,
              email: this.newcontact.value.email
            };
            const filteredData = Object.fromEntries(
              Object.entries(params).filter(([, value]) => value !== '' && value != null)
            );
            if (this.dataerror === null) {
              this.myGroup.reset();
              if (params.phonenumber != null && params.phonenumber !== '') {
                this.myGroup.get('phonenumber')?.setValue(params.phonenumber);
              }
              if (params.firstname != null && params.firstname !== '') {
                this.myGroup.get('firstname')?.setValue(params.firstname);
              }
              if (params.lastname != null && params.lastname !== '') {
                this.myGroup.get('lastname')?.setValue(params.lastname);
              }
              if (params.email != null && params.email !== '') {
                this.myGroup.get('email')?.setValue(params.email);
              }
              this.showNewContactSection = false;
              this.showContactErrorMessage = false;
              this.showContactAlreadyExistsMessage = false;
              this.showSuccessMessage = true;
              this.search({
                queryId: '23',
                offset: 0,
                perpage: 1,
                params: filteredData
              });
            } else {
              this.showContactErrorMessage = true;
              this.showNewContactSection = true;
              this.newcontact.reset();
            }
          });
        } else {
          const filteredData = this.newContactSearchParamsOmitEmpty();
          this.myGroup.reset();
          if (filteredData.phonenumber) {
            this.myGroup.get('phonenumber')?.setValue(this.newcontact.value.phonenumber);
          }
          if (filteredData.firstname) {
            this.myGroup.get('firstname')?.setValue(filteredData.firstname);
          }
          if (filteredData.lastname) {
            this.myGroup.get('lastname')?.setValue(filteredData.lastname);
          }
          if (filteredData.email) {
            this.myGroup.get('email')?.setValue(filteredData.email);
          }
          this.showNewContactSection = false;
          this.showContactErrorMessage = false;
          this.showSuccessMessage = false;
          this.search({
            queryId: '23',
            offset: 0,
            perpage: 100,
            params: filteredData,
            _showContactAlreadyExistsAfterSearch: true
          });
        }
      });
  }

  search(payload: any): void {
    if (this.showNewContactSection) {
      return;
    }

    this.datatableload = false;
    const showAlreadyExistsAfterSearch = payload._showContactAlreadyExistsAfterSearch === true;
    if (Object.prototype.hasOwnProperty.call(payload, '_showContactAlreadyExistsAfterSearch')) {
      delete payload._showContactAlreadyExistsAfterSearch;
    }
    if (!showAlreadyExistsAfterSearch) {
      this.showContactAlreadyExistsMessage = false;
    }

    const params: Record<string, any> = {};
    for (const controlName in this.myGroup.controls) {
      if (this.myGroup.controls.hasOwnProperty(controlName)) {
        const control = this.myGroup.controls[controlName];
        if (control.value) {
          if (controlName === 'phonenumber') {
            params[controlName] = String(control.value).replace(/[^0-9]/g, '');
          } else if (controlName === 'street') {
            params[controlName] = String(control.value).replace(/[^a-zA-Z0-9]/g, '');
          } else {
            params[controlName] = control.value;
          }
        }
      }
    }
    const state = this.country?.find((s) => s.value === this.myGroup.value.stateprovience)?.key;
    const country = this.states?.find((c) => c.value === this.myGroup.value.country)?.key;
    params['stateprovience'] = state;
    params['country'] = country;
    payload.params = params;

    if (payload.params && typeof payload.params === 'object') {
      payload.params = this.trimStringValuesInObject(payload.params as Record<string, unknown>) as Record<
        string,
        any
      >;
    }

    this.subscription?.unsubscribe();
    this.subscription = this.queryProcessorService.searchQueriesService(payload).subscribe({
      next: (data) => {
        this.jsonData = data;
        this.rowcolumns = data.cols;
        this.rowdata = data.rows || [];
        this.dataSource = new MatTableDataSource(data.rows);
        this.dataSource.paginator = this.paginator;
        this.datatablepagination();

        if (data.rows.length === 0) {
          const asignpayload = this.filterEmptyValues(payload);
          if (asignpayload.params && typeof asignpayload.params === 'object') {
            Object.keys(asignpayload.params).forEach((key) => {
              if (this.newcontact.contains(key)) {
                if (key === 'street') {
                  this.newcontact.get(key)?.setValue(this.myGroup.get('street')?.value);
                } else {
                  this.newcontact.get(key)?.setValue(asignpayload.params[key]);
                }
              }
            });
          }
        } else {
          this.newcontact.reset();
        }
        if (showAlreadyExistsAfterSearch && data.rows && data.rows.length >= 1) {
          this.showContactAlreadyExistsMessage = true;
        }
      },
      error: () => {
        /* noop */
      }
    });
    this.showSuccessMessage = false;
  }

  loadContactRow(data: any): void {
    this.dialogRef.close({
      rowdata: data,
      rowcolumns: this.rowcolumns
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  formatPhoneNumber(phoneNumber: string): string {
    let p = phoneNumber;
    if (p.startsWith('+1')) {
      p = p.substring(2);
    }
    const numericPhoneNumber = p.replace(/\D/g, '');
    return numericPhoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  }
}
